var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.25,28.333334C4.25,29.115738,4.88426328,29.75,5.666667,29.75L16.999997999999998,29.75C24.04163,29.75,29.75,24.04163,29.75,17C29.75,9.9583707,24.04163,4.25,17,4.25C9.9583707,4.25,4.25,9.9583707,4.25,17.000002000000002L4.25,28.333334ZM5.6666666,28.333334L16.999999000000003,28.333334Q21.694424,28.333334,25.01388,25.013878Q28.333336,21.694422,28.333336,17.000002000000002Q28.333334,12.3055801,25.013878,8.986123599999999Q21.694422,5.6666662,17.000002000000002,5.6666666Q12.3055811,5.6666666,8.986123599999999,8.986124Q5.6666664,12.3055811,5.6666666,17.000002000000002L5.6666666,28.333334Z",
    fillRule: "evenodd",
    fill: "#004CD3",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.33349609375,
    y: 16.291748046875,
    width: 11.333333015441895,
    height: 1.4166666269302368,
    rx: 0.7083333134651184,
    fill: "#004CD3",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,-1,0,29.041748046875,-6.375244140625)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.70849609375,
    y: 11.333251953125,
    width: 11.333333015441895,
    height: 1.4166666269302368,
    rx: 0.7083333134651184,
    fill: "#004CD3",
    fillOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhone);
export default __webpack_public_path__ + "static/media/add-phone.08b8e1cd15fbd6fc56f0f0dc5c74c5aa.svg";
export { ForwardRef as ReactComponent };